import { Bell, Mail, PhoneCall, Search } from "lucide-react";
import { Outlet } from "react-router";
import { AppSidebar } from "./app-sidebar";
import { NavUser } from "./nav-user";
import { Badge } from "./ui/badge";
import { Input } from "./ui/input";
import { Separator } from "./ui/separator";
import { SidebarInset, SidebarProvider, SidebarTrigger } from "./ui/sidebar";
import { useNavigate } from "react-router";
export function AppLayout() {
  const navigate = useNavigate();

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className="h-screen flex flex-col">
        <header className="flex h-16 shrink-0 items-center gap-4 transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-12 bg-sidebar px-4">
          <div className="flex flex-1 items-center gap-4">
            <SidebarTrigger className="-ml-1 hover:bg-gray-100 rounded-lg transition-colors duration-200" />
            <Separator
              orientation="vertical"
              className="mr-2 data-[orientation=vertical]:h-4 bg-gray-300"
            />

          </div>

          {/* Search Bar */}
          <div className="hidden md:flex relative w-80">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
            <Input
              placeholder="Tìm kiếm..."
              className="pl-10 border-none shadow-none bg-white focus:bg-white transition-colors rounded-full"
            />
          </div>

          {/* Right side - Notifications and User */}
          <div className="flex items-center gap-3">
            <div className="relative">
              <button
                type="button"
                className="p-2 hover:bg-emerald-50 rounded-lg transition-colors"
                onClick={() => navigate("/sip-calls?newCall=1")}
                title="Tạo cuộc gọi mới"
                aria-label="Tạo cuộc gọi mới"
              >
                <PhoneCall className="w-5 h-5 text-emerald-600" />
              </button>
            </div>

            {/* Notifications */}
            <div className="relative">
              <button className="p-2 hover:bg-gray-100 rounded-lg transition-colors relative">
                <Bell className="w-5 h-5 text-gray-600" />
                <Badge className="absolute -top-1 -right-1 w-5 h-5 flex items-center justify-center p-0 bg-red-500 text-white text-xs">
                  1
                </Badge>
              </button>
            </div>

            {/* Messages */}
            <div className="relative">
              <button className="p-2 hover:bg-gray-100 rounded-lg transition-colors" onClick={() => navigate("/messages")}>
                <Mail className="w-5 h-5 text-gray-600" />
              </button>
            </div>

            {/* User Menu */}
            <NavUser />

          </div>
        </header>
        <main className="flex-1 bg-sidebar p-4 pt-0 overflow-y-auto">
          <div className="min-h-full w-full bg-white p-8 rounded-lg">
            <Outlet />
          </div>
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
